import { useCallback, useEffect, useMemo, useState } from 'react'
import { SelectOption } from 'react-spreadsheet-import/types/types'
import debounce from 'lodash/debounce'

import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { useQueryList } from '@percent/admin-dashboard/common/hooks'

const THROTTLING_TIME = 500

export function usePartnerSearchQuery() {
  const { adminService } = useServices()

  const [query, setQuery] = useState<string>('')

  const [{ dataOrNull: partnersData, isLoading }, { query: partnersQuery }] = useQueryList(
    adminService.queries.getPartnerList,
    {
      pageSize: 25
    }
  )

  const searchResults: SelectOption[] = useMemo(() => {
    return partnersData
      ? partnersData.map(partner => ({
          value: partner.id,
          label: partner.name
        }))
      : []
  }, [partnersData])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedPartnerQuery = useCallback(
    debounce<any>((filter: string) => {
      partnersQuery({ query: filter })
    }, THROTTLING_TIME),
    []
  )

  useEffect(() => {
    if (query) {
      debouncedPartnerQuery(query)
    }
  }, [query, debouncedPartnerQuery])

  return {
    searchResults,
    query,
    isLoading,
    setQuery
  }
}
